import { LayoutContext } from 'app/components/ReactContexts/layoutContext';
import { BaseTabs } from 'app/components/Tabs';
import useFlag from 'app/hooks/useFlag';
import { AccessSharingTabs } from 'app/pages/AccessSharingPage/constants';
import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { invitationsApi } from 'services/api/invitations/queries';
import { FeatureName } from 'types/entities/MobileSettings';

export enum AcessSharingFilters {
  All,
  OwnedByMe,
  SharedWithMe,
}

function AccessSharingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { setClassNames, removeClassNames } = useContext(LayoutContext);

  const isAccessSharingPageEnabled = useFlag(FeatureName.ACCESS_SHARING);

  const {
    data: invitations = {
      pendingReceivedInvitations: [],
    },
  } = invitationsApi.useGetInvitationsQuery(undefined, {
    skip: !isAccessSharingPageEnabled,
  });

  const tabs = useMemo(
    () => [
      {
        label: t('equipment_and_fleets'),
        value: AccessSharingTabs.EQUIPMENT_AND_FLEETS,
      },
      { label: t('shared_with'), value: AccessSharingTabs.SHARED_WITH },
      {
        label: t('pending_invitations'),
        value: AccessSharingTabs.PENDING_INVITATIONS,
        badgeContent:
          invitations.pendingReceivedInvitations.length || undefined,
      },
    ],
    [t, invitations.pendingReceivedInvitations.length],
  );

  useEffect(() => {
    let index: number = setClassNames('layout-grey');

    return () => {
      removeClassNames(index);
    };
  }, []);

  const currentTab = location.pathname.split('/').pop();

  const shouldShowTabs = useMemo(
    () => tabs.some(tab => tab.value === currentTab),
    [currentTab],
  );

  return (
    <div className="relative">
      {shouldShowTabs && (
        <>
          <h2 className="title-access-sharing">{t('title_access_sharing')}</h2>
          <BaseTabs
            className="fleet-details-page__tabs"
            tabs={tabs}
            value={currentTab}
            onChange={newTab => navigate(`/access/${newTab}`)}
          />
        </>
      )}

      <Outlet />
    </div>
  );
}

export default AccessSharingPage;
